import "./navbar.scss";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
//import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
//import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { UserAuth } from '../../context/AuthContext'

const Navbar = () => {
  const { dispatch } = useContext(DarkModeContext);
  const { user } = UserAuth();
  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="search" style={{ border: 0 }}>
          {/* <input type="text" placeholder="Search..." />
          <SearchOutlinedIcon className="icon1" /> */}
        </div>
        
        <div className="items">
          <Link to="/users/profile" nome={'AJA'} style={{ textDecoration: "none" }}>
          <div className="item">
            <EmojiPeopleIcon className="icon" />
            Hello, {user?.metadata?.fullname}
          </div>
          </Link>
          <div className="item">
            <DarkModeOutlinedIcon
              className="icon"
              onClick={() => dispatch({ type: "TOGGLE" })}
            />
          </div>
          {/* <div className="item">
            <NotificationsNoneOutlinedIcon className="icon" />
            <div className="counter">1</div>
          </div> */}
          <Link to="/" nome={'AJA'} style={{ textDecoration: "none" }}>
            <div className="item">
              <img
                src={require('../../assets/logo.png')}
                alt=""
                className="avatar"
              />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;